var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 26.5C22.299 26.5 27 21.799 27 16C27 10.201 22.299 5.5 16.5 5.5C10.701 5.5 6 10.201 6 16C6 21.799 10.701 26.5 16.5 26.5ZM16.5 28C23.1274 28 28.5 22.6274 28.5 16C28.5 9.37258 23.1274 4 16.5 4C9.87258 4 4.5 9.37258 4.5 16C4.5 22.6274 9.87258 28 16.5 28Z",
    fill: "#E8F2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0532 11.25C14.4674 11.25 14.8032 11.5858 14.8032 12L14.8032 20C14.8032 20.4142 14.4674 20.75 14.0532 20.75C13.639 20.75 13.3032 20.4142 13.3032 20L13.3032 12C13.3032 11.5858 13.639 11.25 14.0532 11.25Z",
    fill: "#E8F2FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9468 11.25C19.361 11.25 19.6968 11.5858 19.6968 12L19.6968 20C19.6968 20.4142 19.361 20.75 18.9468 20.75C18.5326 20.75 18.1968 20.4142 18.1968 20L18.1968 12C18.1968 11.5858 18.5326 11.25 18.9468 11.25Z",
    fill: "#E8F2FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.c177312236bfe1cc39cb8eb5a53ba7b3.svg";
export { ForwardRef as ReactComponent };